import * as i18n from "../i18n.ts";
import { clearTime, format, getWeekRange, isSameDay, toLocaleString } from "./DateUtils.ts";

  
  
  function dayDiff(now,date){
    return Math.round((clearTime(now).getTime() - clearTime(date).getTime())/(3600000*24));
  }
  const deltatime = {
    
    iso:function(d){
      return d.toISOString();
    },
    deltaday:function(date){
      var 
        now = new Date();
      
      var theDayDiff = dayDiff(now,date);
      if(theDayDiff===1){
        return i18n.get('deltatime.yesterday');
      }
      if(theDayDiff===0){
        return i18n.get('deltatime.today');
      }
      if(theDayDiff===-1){
        return i18n.get('deltatime.tomorrow');
      }
      if(theDayDiff<0 && theDayDiff>-7){
        return format(date,'dddd');
      }
      if(now.getFullYear()!=date.getFullYear()){
        return format(date, 'll');
      }
      var result = toLocaleString(date,{dateStyle:"long"});
      if(now.getFullYear()===date.getFullYear()){
        return result.replace(''+now.getFullYear(),"");
      }else{
        return result;
      }
    },
    longdate:function(date){
      var 
        now = new Date(),
        deltaMinutes = Math.floor((now.getTime()-date.getTime())/60000);

      if(deltaMinutes<2){
        return i18n.get('deltatime.justnow');
      }
      if(deltaMinutes<60){
        return i18n.get('deltatime.minutes',deltaMinutes);
      }
      if(getWeekRange(date).containsToday){
        if(isSameDay(now,date)){
          return toLocaleString(date,{timeStyle:'short'});
        }else{
          return toLocaleString(date,{weekday:"long",hour:"2-digit",minute:"2-digit"});
        }
      }
      var result = toLocaleString(date,{dateStyle:"long",timeStyle:'short'});
      if(now.getFullYear()===date.getFullYear()){
        return result.replace(''+now.getFullYear(),"");
      }else{
        return result;
      }
      
    },
    duedate:function(date){
      
      if(date.getHours()===0 && date.getMinutes()===0){
        return format(date,"ll");
      }else{
        return format(date,"lll");
      }
    },
    daytime:function(date){
      return format(date,'LT');
    },
    day:function(date){
      var 
        now = new Date(),
        dayDiffCalc = dayDiff(now,date);
      
      if(now.getFullYear()!==date.getFullYear()){
        return format(date,'ll');
      }
      
      if(dayDiffCalc===0){
        return i18n.get('deltatime.today');
      }else if(dayDiffCalc===1){
        return i18n.get('deltatime.yesterday');
      }else if(dayDiffCalc>6 || dayDiffCalc<0){
        return toLocaleString(date,{dateStyle:"long"}).replace(''+now.getFullYear(),"");
      }else{
        return format(date,'dddd');
      }
    },
    time:function(date){
      return format(date,'LT');
    },
    fullDateTime:function(date){
      return format(date,'LLLL');
    },
    fullDate:function(date){
      return format(date,'LL');
    }
  };  
  setInterval(function(){
    document.querySelectorAll("*[data-deltatime]").forEach(function(obj){
      var date = new Date(obj.getAttribute("data-deltatime"));
      obj.innerText = (
        deltatime[obj.getAttribute("data-deltatime-format")||"daytime"](date)
      );
    });
  },60000);

  function text(date,format){
    if(!date) return '';
    var 
      value= deltatime[format](date)
    if(format==='iso' || format==='deltaday'){
      return value;
    }
    if(format==='day'){
      return date.format('LL');
    }else{
      return date.format('LLL');
    }
    
  }

  
  function html(date,type,extraCss=''){
    if(!date) return '';
    var 
      buff = '',
      value= deltatime[type](date),
      worthUpdating = false;
    if(type==='iso' || type==='deltaday'){
      return value;
    }
    buff+='<small ';
    if(worthUpdating){
      buff+='data-deltatime="';
      buff+=date.toISOString();
      buff+='" data-deltatime-format="';
      buff+=type;
      buff+='" ';
    }
    buff += 'style="vertical-align:middle;'+extraCss+'" title="';
    if(type==='day'){
      buff += format(date,'LL');
    }else{
      buff += format(date,'LLL');
    }
    buff += '">';
    buff += value;
    buff += '</small>';
    
    return buff;
  }
  
  
export {html,text,deltatime};